import React from 'react';
import {fetchUtils, SelectInput, Button, TabbedForm, FormTab, Filter, BooleanInput, required, Toolbar, SaveButton, 
	DateField, Edit, Create, List, Datagrid, TextField, TextInput, DateInput, SelectArrayInput, FormDataConsumer,
	ReferenceArrayInput, AutocompleteArrayInput } from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const countryChoices = require('./components/countries.json');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/auctions_report';

const adsizeChoices = [
	{id: '970x66', name:'970x66'},
	{id: '300x50', name: '300x50'},
	{id: '336x280', name: '336x280'},
	{id: '970x90', name: '970x90'},
	{id: '320x100', name: '320x100'},
	{id: '970x250', name: '970x250'},
	{id: '160x600', name: '160x600'},
	{id: '300x600', name: '300x600'},
	{id: '728x90', name: '728x90'},
	{id: '320x50', name: '320x50'},
	{id: '300x250', name: '300x250'}
];

const choicesInterval = [
	{ id: 'hour', name: 'Hourly' },
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: 0, name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
	{ id: 'custom', name: 'Custom' }
];
const choicesShow = [
	{ id: 'date', name: 'Date' },
	{ id: 'publisher', name: 'Publisher' },
	{ id: 'site', name: 'Site' },
	{ id: 'bidder', name: 'Bidder' },
	{ id: 'tldomain', name: 'Domain' },
	{ id: 'ad_type', name: 'Ad Type'},
	{ id: 'country', name: 'Country'},
	{ id: 'adsize', name: 'Ad Size'}
];
const choicesAdType = [
  { id: 'banner', name: 'BANNER' },
  { id: 'native', name: 'NATIVE' },
  { id: 'video',  name: 'VIDEO' }
];
const AuctionsTitle = ({ record }) => {
	return <span>Auctions Report {record ? `"${record.name}"` : ''}</span>;
};
const AuctionsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const AuctionsList = (props) => (
	<List {...props} title="Auctions Reports" perPage={25} bulkActionButtons={false} filters={<AuctionsFilter />} 
	exporter={false} >
		<Datagrid rowClick="edit">
			<TextField source="name" label="Name" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
class CustomToolbar extends React.Component {
	state = {
	}
	constructor(props) {
		super(props);
		this.parent = props.parent;
	}
	fetchData() {
		let show='';
		if (formData.show) formData.show.map(item => { show+='&show='+item; });
		let interval = (formData.interval) ? `&interval=${formData.interval}` : '&interval=day';
		let dateRange = '';
		if ('custom'===formData.date_range) {
			dateRange = `&start_date=${formData.start_date}&end_date=${formData.end_date}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

		this.parent.setState({loading: true, total: '---'});
		let url = `${BASE_URL}?r=1${show}${interval}${dateRange}`+
		`${utils.formDataFieldsQueryStringFormat(formData, ['publisher_id', 'site_id', 'bidder_id', 'tldomain', 'ad_type', 'country', 'adsize'])}`;
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		fetch(url, options).then(({ headers, json }) => (
			this.parent.setState({data: json.data, loading: false, total: json.total})
		));
	}
	handleSearch = (props) => {
		this.fetchData();
	}
	render() {
		return <Toolbar>
			<SaveButton style={{marginRight: '10px'}} variant='contained' 
				color='primary' disabled={this.props.parent.state.loading} {...this.props}/>
			<br />
			<Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
				startIcon={<RunReportIcon />} style={{padding: '7px', width: '160px'}} 
				disabled={this.props.parent.state.loading} />
			<br />
			<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
			<TextField source="updated_name" label="" style={{ padding: '10px' }} />
		</Toolbar>
	}
};
let formData = {};
function setFormData(formdata) {
	formData = formdata;
}
class AuctionsForm extends React.Component {
	state = {};
	render() {
		return (
			<TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
			<FormTab label="Report Settings">
				<TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
				<FormDataConsumer>
					{({ formData }) => setFormData(formData) }
				</FormDataConsumer>
				<div style={{ width: '100%', overflow: 'hidden' }}>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Interval" source="interval"
						choices={choicesInterval}
						defaultValue='day'
						disabled={this.props.parent.loading} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Date Range" source="date_range"
						choices={dateRangeChoices}
						onChange={value => this.setState({ date_range: value.target.value })}
						defaultValue="8"
						disabled={this.props.parent.loading} />

						<div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
						<div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="Start Date" source="start_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>

						<div style={{ float: 'left', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="End Date" source="end_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>
						</div>
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectArrayInput label="Show"
						source="show"
						choices={choicesShow}
						defaultValue={['date']}
						style={{ width: '400px' }}
						disabled={this.props.parent.loading} />
					</div>
				</div>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
					
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="publisher_id" 
						label="Publishers" 
						reference="publishers"
						basePath="publishers"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} label="Publishers" optionText="name" optionValue="code"/>
					</ReferenceArrayInput>
					</div>
					
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="site_id" 
						label="Sites" 
						reference="sites"
						basePath="sites"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} 
							label="Sites" 
							optionText={x => (x && x.code) ? `${x.adunit_path} (${x.code})` : ''}
							optionValue="code"/>
					</ReferenceArrayInput>
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="bidder_id" 
						label="Bidder" 
						reference="bidders"
						basePath="bidders"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ bidder_type:'RTB', search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} label="Bidders" 
						optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''} 
						optionValue="code"/>
					</ReferenceArrayInput>
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput label="Ad Type" 
					source="ad_type" 
					choices={choicesAdType} 
					style={{ width: '150px' }}
					disabled={this.props.parent.loading} />
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput label="Country" 
					source="country" 
					choices={countryChoices} 
					style={{ width: '300px' }}
					disabled={this.props.parent.loading} />
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput label="Ad Size" 
					source="adsize" 
					choices={adsizeChoices} 
					style={{ width: '150px' }}
					disabled={this.props.parent.loading} />
					</div>

					<div style={{ float: 'left', paddingRight: '10px' }}>
					<TextInput source="tldomain" label="Domain / App" style={{ width: '400px' }} />
					</div>
				</div>
			</FormTab>
			</TabbedForm>
		)
	}
}
let BASE_COLUMNS = [
	{ name: 'Date', selector: 'date', sortable: true, cell: row => ('' + row.date) },
	{ name: 'Publisher', selector: 'publisher_name', sortable: true, cell: row => <span>{ `${row.publisher_name} (${row.publisher_id})` }</span> },
	{ name: 'Site', selector: 'site_name', sortable: true, cell: row => <span>{ `${row.site_name} (${row.site_id})` }</span> },
	{ name: 'Bidder', selector: 'bidder_name', sortable: true, cell: row => <span>{ `${row.bidder_name} (${row.bidder_id})` }</span> },
	{ name: 'Ad Type', selector: 'ad_type', sortable: true, cell: row => <span>{ `${row.ad_type?row.ad_type.toUpperCase():'NA'}` }</span> },
	{ name: 'Domain', selector: 'tldomain', sortable: true },
	{ name: 'Country', selector: 'country', sortable: true },
	{ name: 'Ad Size', selector: 'adsize', sortable: true },
	{ name: 'Bid Requests', selector: 'bid_requests', sortable: true, cell: row => utils.formatLong(row.bid_requests) },
	{ name: 'Bid Responses', selector: 'bid_responses', sortable: true, cell: row => utils.formatLong(row.bid_responses) },
	{ name: '% Response Rate', selector: 'response_rate', sortable: true, cell: row => utils.formatDouble(row.response_rate, ' ') },
	{ name: 'Impressions', selector: 'impressions', sortable: true, cell: row => utils.formatLong(row.impressions) },
	{ name: '% Fill Rate', selector: 'fill_rate', sortable: true, cell: row => utils.formatDouble(row.fill_rate, ' ') },
	{ name: '% Win Rate', selector: 'win_rate', sortable: true, cell: row => utils.formatDouble(row.win_rate, ' ') },
	{ name: '$ Revenue', selector: 'revenue', sortable: true, cell: row => utils.formatDouble(row.revenue) },
	{ name: '$ Avg Bid Price', selector: 'avg_bid_price', sortable: true, cell: row => utils.formatDouble(row.avg_bid_price, null, 5) },
	{ name: '$ Avg Floor', selector: 'avg_floor_price', sortable: true, cell: row => utils.formatDouble(row.avg_floor_price, null, 5) },
	{ name: '$ Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => utils.formatDouble(row.avg_cpm, null, 5) }
];
let columns = [];
const conditionalRowStyles = [
	{   
			when: row => (row.response_rate <= 5 || row.fill_rate <= 0),
			style: {color: 'red', backgroundColor: 'white'}
	},
	{   
		when: row => (row.response_rate >= 10  && row.fill_rate >= 0.5),
			style: {color: 'green', backgroundColor: 'white'}
	},
];
class AuctionsUpsert extends React.Component {
	state = {
		data: [],
		loading: false,
		total: '---'
	};
	setState(obj) {
		if (obj.data && obj.data.length>0) {
			let keys = Object.keys(obj.data[0]);
			columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
		}
		super.setState(obj);
	}
	render(props) {
		const { data, loading, total } = this.state;
		return (
		<div>
			{this.props.formType === "edit" &&
				<Edit title={<AuctionsTitle />} {...this.props}>
					<AuctionsForm formType="edit" parent={this}/>
				</Edit>
			}
			{this.props.formType === "create" &&
				<Create title="Create Auctions Report" {...this.props}>
					<AuctionsForm formType="create" parent={this}/>
				</Create>
			}
			<DataTable
				title={`${total} Matching Results`}
				theme={window.nobid_table_theme()}
				columns={columns}
				data={data}
				progressPending={loading}
				pagination
				fixedHeader
				dense
				conditionalRowStyles={conditionalRowStyles}
				paginationPerPage={30}
				paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
				subHeader={!loading}
				subHeaderComponent={
					(
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input type="text" id='search_box' label="Search"
						variant="outlined"
						style={{ margin: '5px' }}
						onChange={(target) => dataSupport.filterData(this)} />
						<CloudDownload
						label="Export"
						style={{ margin: '5px' }}
						color="action"
						onClick={() => dataSupport.exportData(this.state.data)}
						/>
					</div>
					)
				}
			/>
		</div>
		)
	}
}

export const AuctionsEdit = (props) => (
	<AuctionsUpsert formType="edit" {...props} />
);

export const AuctionsCreate = (props) => (
	<AuctionsUpsert formType="create" {...props} />
);